export const AMOUNT = 'amount';

export const MINUTES = 'minutes';

export const TREATMENTS = 'treatments';
